import { isEmpty } from "lodash";
import { Company } from "./Company";
import { Location } from "./Location";
import { Validate } from "./Validate";
import { getDictionary } from "../utilities/utilities";

const dictionary = getDictionary();

export interface AddressBook {
  id: string;
  creationDate: string;
  creationUser: string;
  lastModifiedDate: string;
  lastModifiedUser: string;
  ownerId: string;
  owner: Company;
  name: string;
  email?: string;
  pec?: string;
  phone?: string;
  mobilePhone?: string;
  contactName?: string;
  priv: boolean;
  ztl: boolean;
  myAddress: boolean;
  gdo: boolean;
  location: Partial<Location>;
  vatNumber?: string;
  fiscalCode?: string;
  sdi?: string;
  externalReference?: string;
  locationId: string;

  registryId?: string; //FE
}

export interface CreateAddressBook {
  name: string;
  priv: boolean;
  ztl: boolean;
  gdo: boolean;
  myAddress: boolean;
  locationId: string;
  ownerId?: string;
  email?: string;
  pec?: string;
  phone?: string;
  mobilePhone?: string;
  contactName?: string;
  vatNumber?: string;
  fiscalCode?: string;
  sdi?: string;
  externalReference?: string;
}

export interface UpdateAddressBook extends CreateAddressBook {
  id: string;
  ownerId?: string;
  email?: string;
  pec?: string;
  phone?: string;
  mobilePhone?: string;
  contactName?: string;
  vatNumber?: string;
  fiscalCode?: string;
  sdi?: string;
  externalReference?: string;
}

// Convert function to create
export const convertAddressBookToCreate = (
  addressBook: AddressBook,
): CreateAddressBook => {
  return {
    name: addressBook.name,
    priv: addressBook.priv,
    ztl: addressBook.ztl,
    gdo: addressBook.gdo,
    myAddress: addressBook.myAddress,
    locationId: addressBook.location.id as string,
    ownerId: addressBook.ownerId,
    email: addressBook.email,
    pec: addressBook.pec,
    phone: addressBook.phone,
    mobilePhone: addressBook.mobilePhone,
    contactName: addressBook.contactName,
    vatNumber: addressBook.vatNumber,
    fiscalCode: addressBook.fiscalCode,
    sdi: addressBook.sdi,
    externalReference: addressBook.externalReference,
  };
};

// Convert function to update
export const convertAddressBookToUpdate = (
  addressBook: AddressBook,
): UpdateAddressBook => {
  return {
    id: addressBook.id,
    name: addressBook.name,
    priv: addressBook.priv,
    ztl: addressBook.ztl,
    gdo: addressBook.gdo,
    myAddress: addressBook.myAddress,
    locationId: addressBook.location.id as string,
    ownerId: addressBook.ownerId,
    email: addressBook.email,
    pec: addressBook.pec,
    phone: addressBook.phone,
    mobilePhone: addressBook.mobilePhone,
    contactName: addressBook.contactName,
    vatNumber: addressBook.vatNumber,
    fiscalCode: addressBook.fiscalCode,
    sdi: addressBook.sdi,
    externalReference: addressBook.externalReference,
  };
};

export const validate = (addressBook: AddressBook): Validate => {
  const validate: Validate = { isValid: true, errors: {} };
  if (!addressBook.contactName) {
    validate.errors.contactName = dictionary.messages.mandatory_field;
  }
  if (addressBook.myAddress === null || addressBook.myAddress === undefined) {
    validate.errors.myAddress = dictionary.messages.mandatory_field;
  }
  if (!addressBook.location) {
    validate.errors.location = dictionary.messages.mandatory_field;
  }
  if (!isEmpty(validate.errors)) {
    validate.isValid = false;
  }
  return validate;
};

export const normalize = (addressBook: AddressBook): AddressBook => {
  const normalized = { ...addressBook };
  if (addressBook.priv === true) {
    normalized.name = addressBook.contactName || "";
  }
  return normalized;
};
